module.exports = __webpack_public_path__ + "static/media/thumb6.17505ddc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/thumb6.jpg
// module id = 645
// module chunks = 0